import AdminSetUserMailVerified from "./AdminSetUserMailVerified";

export default AdminSetUserMailVerified;
